import { Component, OnInit, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { DatePipe } from '@angular/common';
import { TaskSaveService } from 'app/modules/task/services/task-save.service';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'app-task-change-date',
    templateUrl: './task-change-date.component.html',
    styleUrls: ['./task-change-date.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class TaskChangeDateComponent implements OnInit {

  @Input() FormElement: UntypedFormControl;

  FromDate = new Date();
  constructor(
    public dialogRef: MatDialogRef<TaskChangeDateComponent>,
    public sharedService: SharedService,
    public selectionService: SelectionGenericService,
    public taskService: TaskSaveService
  ) {
  }

  ngOnInit(): void {
  }

}
